export const SHOPIFY_URL = 'https://admin.shopify.com/';
export const GIF_URL =
    ' https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/96878bde277e8918068cd861a4a14718-1748615431939/02_Link%20your%20store';
